import { cva } from "../../styled-system/css";

export const contentWrapper = cva({
  base: {
    px: { base: "20px", md: "40px" },
    py: "24px",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    maxWidth: { base: "100vw", md: "100%" },
    position: "relative",
  }
});
